import React from "react";
import { Link } from "react-router-dom";
import HarvestingQuality from "../../assets/img/Service/HarvestingQuality.jpg";
import Customizationdistributions from "../../assets/img/Service/Customizationdistributions.jpg";
import ProcessingRefining from "../../assets/img/Service/Processing_Refining.jpg";
import Storageandlogisitices from "../../assets/img/Service/Storageandlogisitices.jpg";
import Processing_Refining from '../../assets/img/icons/Processing_Refining.svg';

function ProjectsTab() {
  return (
    <section className="our-info-tabs-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-12 col-xl-12">
            <div className="project-tabs-wrapper">
              <ul className="nav nav-pills" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-tab1"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-tab-1"
                    type="button"
                    role="tab"
                    aria-controls="pills-tab-1"
                    aria-selected="true"
                  >
                    {/* <img src={Processing_Refining} alt=""/>   */}
                    Sourcing & Production{" "}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-tab2"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-tab-2"
                    type="button"
                    role="tab"
                    aria-controls="pills-tab-2"
                    aria-selected="false"
                  >
                   {/* <img src={Processing_Refining} alt=""/> {" "} */}
                    Processing & Refining{" "}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-tab3"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-tab-3"
                    type="button"
                    role="tab"
                    aria-controls="pills-tab-3"
                    aria-selected="false"
                  >
                    {/* <i className="flaticon-operation"></i> */}
                     Storage & Logistics{" "}
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-tab4"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-tab-4"
                    type="button"
                    role="tab"
                    aria-controls="pills-tab-4"
                    aria-selected="false"
                  >
                    {/* <i className="flaticon-bar-chart"></i> */}
                     Customization &
                    Distribution{" "}
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-tab-1"
                  role="tabpanel"
                  aria-labelledby="pills-tab-1"
                >
                  <div className="tab-content-wrapper">
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <h2>Harvesting Quality from Trusted Sources</h2>
                        <p>
                        At Shree Gita, we believe that superior quality begins with responsible sourcing and is perfected through meticulous production. We carefully select raw materials from trusted, ethical sources, ensuring purity and consistency from the start. Our strong partnerships with reliable suppliers guarantee authenticity, sustainability, and uncompromised standards.
                        </p>
                        {/* <div className="data-flex">
                                                <div className="single-data">
                                                    <p>POF</p>
                                                    <span>Elemental</span>
                                                    <h6>24.658 <span>Mon</span></h6>
                                                </div>
                                                <div className="single-data">
                                                    <p>HUI</p>
                                                    <span>Special</span>
                                                    <h6>224.658 <span>Year</span></h6>
                                                </div>
                                            </div> */}
                        {/* <Link to="/projectDetails">
                          Read More <i className="fas fa-long-arrow-right"></i>
                        </Link> */}
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="tab-img">
                          <img src={HarvestingQuality} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-tab-2"
                  role="tabpanel"
                  aria-labelledby="pills-tab-2"
                >
                  <div className="tab-content-wrapper">
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <h2>Turning Raw Materials into Refined Excellence</h2>
                        <p>
                          {" "}
                          Quality starts with careful sourcing from trusted, ethical sources, ensuring authenticity and consistency. Using advanced refining techniques, raw materials are processed to enhance purity while maintaining their natural integrity. Strict quality controls and cutting-edge technology ensure every product meets the highest standards, delivering excellence and reliability at every step.
                        </p>
                        {/* <div className="data-flex">
                                                <div className="single-data">
                                                    <p>POF</p>
                                                    <span>Elemental</span>
                                                    <h6>24.658 <span>Mon</span></h6>
                                                </div>
                                                <div className="single-data">
                                                    <p>HUI</p>
                                                    <span>Special</span>
                                                    <h6>224.658 <span>Year</span></h6>
                                                </div>
                                            </div> */}
                        {/* <Link to="/projectDetails">
                          Read More <i className="fas fa-long-arrow-right"></i>
                        </Link> */}
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="tab-img">
                          <img src={ProcessingRefining} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-tab-3"
                  role="tabpanel"
                  aria-labelledby="pills-tab-2"
                >
                  <div className="tab-content-wrapper">
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <h2>Seamless Storage and Global Distribution</h2>
                        <p>
                        Advanced storage solutions preserve product integrity, maintaining optimal conditions for freshness and quality. A well-organized logistics network ensures efficient handling and timely delivery, guaranteeing that products reach their destination safely and in perfect condition. With a focus on precision and reliability, every step of storage and logistics is designed to uphold the highest standards of excellence.
                        </p>
                        {/* <div className="data-flex">
                                                <div className="single-data">
                                                    <p>POF</p>
                                                    <span>Elemental</span>
                                                    <h6>24.658 <span>Mon</span></h6>
                                                </div>
                                                <div className="single-data">
                                                    <p>HUI</p>
                                                    <span>Special</span>
                                                    <h6>224.658 <span>Year</span></h6>
                                                </div>
                                            </div> */}
                        {/* <Link to="/projectDetails">
                          Read More <i className="fas fa-long-arrow-right"></i>
                        </Link> */}
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="tab-img">
                          <img src={Storageandlogisitices} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-tab-4"
                  role="tabpanel"
                  aria-labelledby="pills-tab-2"
                >
                  <div className="tab-content-wrapper">
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <h2>Tailored Solutions for Every Business Need</h2>
                        <p>
                        Flexible customization solutions ensure products meet specific needs, from unique formulations to specialized packaging. A streamlined distribution network enables fast, reliable delivery, ensuring products reach the right place at the right time. With a focus on precision and efficiency, every step is designed to provide personalized solutions and seamless supply chain management.
                        </p>
                        {/* <div className="data-flex">
                                                <div className="single-data">
                                                    <p>POF</p>
                                                    <span>Elemental</span>
                                                    <h6>24.658 <span>Mon</span></h6>
                                                </div>
                                                <div className="single-data">
                                                    <p>HUI</p>
                                                    <span>Special</span>
                                                    <h6>224.658 <span>Year</span></h6>
                                                </div>
                                            </div> */}
                        {/* <a href="project-details.html">
                          Read More <i className="fas fa-long-arrow-right"></i>
                        </a> */}
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="tab-img">
                          <img src={Customizationdistributions} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProjectsTab;
